import { InnerBar, Progress, Wrapper } from "@components/Loading/styled";
import { useEffect, useState } from "react";

function PageLoading() {
  const [percent, setPercent] = useState(0);
  useEffect(() => {
    const tid = setTimeout(() => {
      setPercent(98);
    }, 0);
    return () => {
      clearTimeout(tid);
    };
  }, []);
  return (
    <Wrapper>
      <Progress>
        <InnerBar percent={percent} />
      </Progress>
    </Wrapper>
  );
}

export default PageLoading;
